// Workaround for using custom ajax spinner within the button
const gfCustomSpinner = () => {
    $(document).bind('gform_post_render', () => {
        $('.input-container input, .input-container textarea')
            .keyup((e) => {
                const el = e.currentTarget;
                if ($(el).val().length > 0) {
                    $(el).addClass('filled');
                } else {
                    $(el).removeClass('filled');
                }
            })
            .change((e) => {
                const el = e.currentTarget;
                if ($(el).val().length > 0) {
                    $(el).addClass('filled');
                } else {
                    $(el).removeClass('filled');
                }
            });

        $('.input-container input, .input-container textarea').each((i, e) => {
            if ($(e).val().length > 0) {
                $(e).addClass('filled');
            }
        });
    });

    $('body').on('click', '.gform_button', (el) => {
        $(el.currentTarget).addClass('active');
    });
};

// Export public methods
export { gfCustomSpinner };
